import { render, staticRenderFns } from "./PasteImageField.vue?vue&type=template&id=92f5a626&scoped=true"
import script from "./PasteImageField.vue?vue&type=script&lang=js"
export * from "./PasteImageField.vue?vue&type=script&lang=js"
import style0 from "./PasteImageField.vue?vue&type=style&index=0&id=92f5a626&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f5a626",
  null
  
)

export default component.exports